import { Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { UpsertBroadcastModal } from "~pages/Fixtures/BroadcastPage/components/UpsertBroadcastModal.tsx";
import type { Broadcast } from "~types/broadcast.ts";

type Props = {
  broadcasts: Array<Broadcast>;
  onAdd: (data: Array<Broadcast>) => Promise<unknown>;
  loading: boolean;
};
export const AddBroadcastButton = ({ broadcasts, onAdd, loading }: Props) => {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const handleAdd = async (dataSource: Broadcast) => {
    await onAdd([...broadcasts, dataSource]);
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && <UpsertBroadcastModal isOpen={isOpen} onCancel={() => setIsOpen(false)} loading={loading} onOk={handleAdd} />}
      <Button
        disabled={loading}
        type="primary"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        {formatMessage({ id: "broadcast.add" })}
      </Button>
    </>
  );
};
